export const UPDATE_HISTORY = 'Global/UPDATE_HISTORY';

export const updateHistory = (history) => async (dispatch) => {
  dispatch({
    type: UPDATE_HISTORY,
    payload: { history },
  });
};
